<template>
<!-- 活动风采 -->
    <div class="active">
        <div class="active_title">
            <div class="left">
                活动风采
            </div>
            <div class="right" @click="showMore()">
                更多 >
            </div> 
        </div>

        <div class="list_box">
            <div class="item_box" v-for="(item, index) in NewsList" :key="index" @click="showDetail(item)">
                <div class="cover_img">
                    <img :src="$imgUrl + item.news_headpic" alt="" v-if="item.news_headpic.indexOf('http') == -1">
                    <img :src="item.news_headpic" alt="" v-else>
                </div>
                <p>{{ item.news_title }}</p>
            </div>
        </div>
</div>
</template>

<script>
export default {
    data(){
        return {
            cate_id: 284,
            NewsList:[]
        }
    },
    mounted(){
        this.getNewsList()
    },
    methods:{
        // 获取新闻列表
        async getNewsList () {
            let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id: this.cate_id, pageSize: 8 })
            if ( res.data.code == 1 ) {
                this.NewsList = res.data.res
            } 
        },
        // 查看更多
        showMore () {
            this.$router.push({
                path:"/moreNewsList",
                query: {
                    cate_id: this.cate_id,
                    isSearch: 0,
                    keyword: "",
                }
            })
        },
        // 查看详情
        showDetail ( item ) {
            this.$router.push({
                path:`/NewsDetail/${item.news_id}`,
                query: {
                    cate_id: item.cate_id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.active {
    width: 1200px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 0 auto;
    .active_title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #2767c4 ;
        .left {
            font-size: 24px;
            color: #2767c4 ;
            font-weight: bold;
        }
        .right {
            font-size: 14px;
            color: #B3B3B3;
            cursor: pointer;
        }
    }
    .list_box{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .item_box{
            width: 285px;
            margin: 20px 20px 20px 0;
            &:nth-child(4n){
                margin-right: 0;
            }
            &:hover{
                .cover_img{
                    img{
                        transform: scale(1.1);
                    }
                }
                p{
                    color: #2767C4;
                }
            }
            .cover_img{
                width: 285px;
                height: 214px;
                overflow: hidden;
                img{
                    width: 100%;
                    height: inherit;
                    transition: all 1s;
                }
            }
            p{
                height: 52px;
                font-size: 16px;
                line-height: 26px;
                margin-top: 5px;
                overflow:hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                display: -webkit-box;
                -webkit-box-orient: vertical;

            }
        }
    }
}
</style>